export default "__VITE_ASSET__ee89bb60__"